import React from 'react';
import { Outlet } from 'react-router-dom';
import MarketingHeader from './MarketingHeader';
import MarketingFooter from './MarketingFooter';
import '../landing.css';

interface MarketingLayoutProps {
  children?: React.ReactNode;
}

const MarketingLayout: React.FC<MarketingLayoutProps> = ({ children }) => {
  const body = children ?? <Outlet />;

  return (
    <div className="cp-marketing-layout cp-landing-shell">
      <MarketingHeader />
      <main className="cp-marketing-main">{body}</main>
      <MarketingFooter />
    </div>
  );
};

export default MarketingLayout;
